import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  type SelectChangeEvent
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import type { FocusEventHandler } from 'react';
import type { ComboBoxDataItem } from '../../utils/transform-to-options';

interface ComboBoxProps {
  label: string;
  name?: string;
  options: ComboBoxDataItem[];
  value: string | number;
  error?: boolean;
  helperText?: string;
  onChange: (event: SelectChangeEvent<any>) => void;
  onBlur?: FocusEventHandler;
  disabled?: boolean;
}

const ComboBox = ({
  label,
  name,
  options,
  value,
  error,
  helperText,
  onChange,
  onBlur,
  disabled
}: ComboBoxProps) => {
  const theme = useTheme();
  return (
    <FormControl fullWidth>
      <InputLabel error={error}>{label}</InputLabel>
      <Select
        fullWidth
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        error={error}
        disabled={disabled}
      >
        {options.map((option) => (
          <MenuItem
            value={option.value}
            key={`item-${option.value}`}
            disabled={option.disabled === true}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {helperText && (
        <FormHelperText sx={error ? { color: theme.palette.error.main } : {}}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default ComboBox;
